<template>
  <!------------------------------------------
    The standard layout component for maps.
  -------------------------------------------->
  <div :id="mapContainerId" class="map-container">
    <div :id="mapContainerId + '-loading-div'" class="loading-div" v-if="loading === true"><div class="spinner" :id="mapContainerId + 'spinner'"></div></div>
    <v-expansion-panels v-if="showLayerPanel" accordion :id="mapContainerId + 'layer-controls'" class="layer-controls" v-model="layerPanelVal">
      <v-expansion-panel key="index">
        <v-expansion-panel-header>
          {{ panelTitle }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <slot></slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div :id="mapContainerId + 'legend'" class="legend" v-if="showLegend === true">
      <div :id="mapContainerId + 'legend-contents'" class="legend-contents">
        <div :id="mapContainerId + 'legend-gradient'" class="legend-gradient"></div>
        <div :id="mapContainerId + 'legend-labels'" class="legend-labels">
          <div :id="mapContainerId + 'legend-max'" class="legend-max"></div>
          <div :id="mapContainerId + 'legend-min'" class="legend-min"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapTemplate',
  props: {
    mapContainerId: { type: String, required: true },
    panelTitle: { type: String, required: false, default: 'Data & Options'},
    showLayerPanel: { type: Boolean, required: false, default: true },
    showLegend: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false },
    mapHeight: { type: String, required: true },
    layerPanel: { type: Number, required: false, default: 0 } // 0 = starts open
  },
  data () {
    return {
      layerPanelVal: 0
    }
  },
  mounted () {
    document.getElementById(this.mapContainerId).style.height = this.mapHeight
    this.layerPanelVal = this.layerPanel
  },
  watch: {
    layerPanel (to) {
      this.layerPanelVal = to
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/mapbox-gl.css';
@import '../../scss/vars.scss';
.map-container {
  width: 100%;
  height: 100%; //calc(100vh - 125px);
  position: relative;

  .loading-div {
    background-color: rgba(230, 230, 230, 0.888);
    padding-top: 5rem;
    position: relative;
    z-index: 50;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;

    .spinner {
      display: inline-block;
      width: 50px;
      height: 50px;
      border: 3px solid rgba(255, 255, 255, 0.888);
      border-radius: 50%;
      border-top-color: $main-blue;
      animation: spin 1s ease-in-out infinite;
      -webkit-animation: spin 1s ease-in-out infinite;
    }
    @keyframes spin {
      to { -webkit-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
      to { -webkit-transform: rotate(360deg); }
    }
  }

  .legend {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
    padding: 0.75rem;
    position: absolute;
    left: 10px;
    bottom: 40px;
    z-index: 1;

    .legend-contents {
      display: flex;
      height: 10rem;

      .legend-gradient {
        min-width: 2rem;
        max-width: 2rem;
        background-color: #fff;
        margin: 0.5rem;
      }
      .legend-labels {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}

.layer-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  min-width: 250px;
  max-width: 250px;
  border-radius: 4px;
  background-color: rgba(246, 246, 246, 0.85);
  z-index: 1;

  .v-expansion-panel-header {
    font-weight: bold;
    font-style: italic;
  }

  .layer-controls-header {
    color: $header-red;
    text-transform: uppercase;
    font-size: 0.8rem;
    padding-bottom: 0.5rem;
  }

  .layer-controls-header:not(.first-header) {
    padding-top: 1rem;
  }

  .layers-control-group {
    max-height: 200px;
    overflow-y: auto;
  }

  input {
    margin-top: 0.25rem;
    margin-right: 0.5rem;
  }

  .menu-radio-pair {
    display: flex;
    align-items: flex-start;
  }
  
  .show-offices-layer-group {
    visibility: hidden;
  }
}

.area-popup {
  min-width: 250px;

  .area-popup-name {
    text-transform: uppercase; 
    color: #5a5a5a; 
    font-size: 0.85rem; 
    margin-bottom: 8px; 
    text-align: center; 
    color: white; 
    background-color: #175991; 
    padding: 3px 1px; 
    border-radius: 4px;
  }

  .area-popup-var {
    display: flex; 
    flex-wrap: nowrap; 
    justify-content: space-between; 
    font-size: 0.9rem; 
    margin: 8px 0;

    .popup-var-value {
      padding-left: 0.75rem;
    }
  }

  .area-popup-var-value {
    font-weight: bold;
    padding-left: 0.75rem;
  }

  .area-popup-related-header {
    border-top: 1px solid #ddd; 
    color: #5a5a5a; 
    font-size: 0.85rem; 
    font-style: italic; 
    margin: 12px 0 8px 0; 
    padding-top: 8px;
  }
}

</style>